"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.headerReducer = exports.docAgreementReducer = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _constants = require("./constants");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var headerReducer = function headerReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    default:
      return state;
  }
};
exports.headerReducer = headerReducer;
var docAgreementReducer = function docAgreementReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    isDocumentViewed: false,
    iframeURL: '',
    INSTRUCTIONS: _constants.INSTRUCTIONS,
    BROWSER_SUPPORT_MESSAGE: _constants.BROWSER_SUPPORT_MESSAGE,
    esignAgreementChecked: false,
    loanAgreementChecked: false,
    applicationTermsAgreementChecked: false,
    data: '',
    navigationToNextPage: false,
    submissionInProgress: false,
    reloadPage: false,
    disclosureCopy: {
      LCYTS: {
        ADS: 'By checking this box and clicking “I Agree” below, I am electronically signing the Sales Receipt and authorize Your Tuition Solution to remit the above amount to my provider. I further agree that I have read and received a copy of the Credit Account Agreement from Comenity Capital Bank.',
        NBT: 'By clicking this box, you agree that you have read and agree to the electronic Loan Agreement and Disclosure Form provided above.'
      },
      LCPS: {
        ADS: 'By checking this box and clicking “I Agree” below, I am electronically signing the Sales Receipt and authorize Lending Club Patient Solutions to remit the above amount to my provider. I further agree that I have read and received a copy of my Lending Club Patient Solutions Credit Account Agreement from Comenity Capital Bank.',
        NBT: 'By clicking this box, you agree that you have read and agree to the electronic Loan Agreement and Disclosure Form provided above.'
      }
    },
    error: false
  };
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case _constants.FETCH_DOCUMENT:
      return _objectSpread(_objectSpread({}, state), {}, {
        data: action.payload.data,
        error: action.payload.error
      });
    case _constants.UPDATE_FORM_FIELD:
      return _objectSpread(_objectSpread({}, state), {}, {
        loanAgreementChecked: action.payload.loanAgreementChecked,
        applicationTermsAgreementChecked: action.payload.applicationTermsAgreementChecked,
        esignAgreementChecked: action.payload.esignAgreementChecked,
        isDocumentViewed: action.payload.isDocumentViewed,
        error: action.payload.error
      });
    case _constants.VALIDATE_AND_SUBMIT_INPROGRESS:
      return _objectSpread(_objectSpread({}, state), {}, {
        submissionInProgress: action.payload.submissionInProgress,
        navigationToNextPage: action.payload.navigationToNextPage
      });
    case _constants.VALIDATE_AND_SUBMIT:
      return _objectSpread(_objectSpread({}, state), {}, {
        submissionInProgress: action.payload.submissionInProgress,
        navigationToNextPage: action.payload.navigationToNextPage,
        error: action.payload.error,
        reloadPage: action.payload.reloadPage
      });
    default:
      return state;
  }
};
exports.docAgreementReducer = docAgreementReducer;
